import {
    doorDataProps, moduleItem, railGroup,
    SceneObjects, sides,
    storeConfigurationState,
    wardrobeModule,
    windowDataProps,
    Shelf, iWalls, boxDataProps,
} from '@/Interfaces/common';
import { Room } from '@/Engine/Room';
import { Door } from '@/Engine/Door';
import { Window } from '@/Engine/Window';
import { V3dTools } from '@/v3d/common';
import { Wardrobe } from '@/Engine/Wardrobe/Wardrobe';
import { Mesh, Vector3 } from 'three';
import { IV3D } from '@/Interfaces/v3d';
import { iApp } from '@/Interfaces/app';
import { RackModule } from '@/Engine/Wardrobe/RackModule';
import { Font } from 'three/examples/jsm/loaders/FontLoader';
import { selectionBox, SelectionBox } from '@/Engine/SelectionBox';
import { _checkCollision } from '@/Engine/checkCollision';
import { Camera } from '@/Engine/camera';
import { TextMesh } from '@/Engine/Ruler/TextMesh';
import { LineDotted } from '@/Engine/Primitives/LineDotted';
import { BoxItem } from '@/Engine/Box';
import { SelectionBoxForBox, selectionBoxForBox } from '@/Engine/SelectionBoxForBox';
import { getLineMeshWithDashes } from '@/lib/getLineWithDashes';

declare let v3d: IV3D;

export class GlobalState {
    addConnector?: boolean;
    tempModule: wardrobeModule | null = null;
    tempShelf: moduleItem | null = null;
    tempRail: railGroup | null = null;
    tempModuleChildParentUUID: string | null = null;
    tempWindowData: windowDataProps | null = null;
    tempDoorData: doorDataProps | null = null;
    tempBoxData: boxDataProps | null = null;
    selection = false;
    mouseDown = false;
    dockedShelf: any | null = null;
    eventsNum = 0;
    container?: HTMLElement;
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    v3dTools: V3dTools;
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    room: Room;
    doors: Array<Door> = [];
    windows: Array<Window> = [];
    boxes: Array<BoxItem> = [];
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    wardrobe: Wardrobe;
    moved = false;
    dragging = false;
    bigDistanceFlag = false; // true полка перемещается внутри модуля
    pointer = new v3d.Vector2();
    wallPointer: null | Vector3 = null;
    floorPointer: null | Vector3 = null;
    shelfPlace: number | null = null;
    ctrlKey = false;
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    app: iApp;
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    camera: Camera;
    replaceShelfToNewModule = false;
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    targetRackModule: RackModule;
    //TODO вынести тип отдельно
    decorModels: Map<string, { model: Mesh, raw: any }> = new Map();
    decorModelsBySurface: Map<string, Array<{ model: Mesh, raw: any }>> = new Map();
    mode = 1;
    isDecoration = false;
    selectedRoomType: string | null = null;
    tempKit: storeConfigurationState | null = null;
    font: Font | undefined;
    isRuler = true;
    toDeleteUUIDs: Array<string> = [];
    toDeleteRacksUUIDs: Array<string> = [];
    createNewModule: string | null = null;
    updated = false;
    overlayGroup = new v3d.Group();
    sceneBackGround: any;
    pauseRender = false;
    selectionBox: SelectionBox | null = null;
    selectionBoxForBox: SelectionBoxForBox | null = null;
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    render: (cb?: () => void) => void;
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    checkCollision: (object: SceneObjects, side: string, excludeUUIDs: string[] = []) => SceneObjects;
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    checkGroupCollision: (selectionBox: SelectionBox, sourceObjects: Array<RackModule | Shelf>, side: string) => boolean;
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    checkShelfCollision: (object: SceneObjects, side: string) => SceneObjects;
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    checkShelfCollisionWithExclude: (object: SceneObjects, side: string, excludeUUIDs: string[]) => SceneObjects;
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    checkAllShelfCollisionWithExclude: (object: SceneObjects, side: string, excludeUUIDs: string[]) => SceneObjects[];
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    checkCollisionWithRack: (object: SceneObjects, side: string, excludeUUIDs: string[]) => SceneObjects;

    checkShelfCollisionWithWall = (object: SceneObjects, side: string): any => {
        return _checkCollision(object, [ ...$.windows, ...$.doors, ...$.room.getObb(side) ]);
    };

    removeDoorByUUID(uuid: string) {
        const index = this.doors.findIndex((door) => door.uuid === uuid);
        if (index === -1) return;
        this.doors[index].model.removeFromParent();
        this.doors.splice(index, 1);
    }

    removeBoxByUUID(uuid: string) {
        const index = this.boxes.findIndex((box) => box.uuid === uuid);
        if (index === -1) return;
        this.boxes[index].model.removeFromParent();
        this.boxes.splice(index, 1);
    }

    removeWindowsByUUID(uuid: string) {
        const index = this.windows.findIndex((window) => window.uuid === uuid);
        if (index === -1) return;
        this.windows[index].model.removeFromParent();
        this.windows.splice(index, 1);
    }

    getAllObjects() {
        return [ ...this.doors, ...this.windows, ...this.wardrobe.rackModules, ...this.wardrobe.shelves, ...this.room.obbs ];
    }

    getAllObjectsWithoutShelf() {
        return [ ...this.doors, ...this.windows, ...this.wardrobe.rackModules, ...this.room.obbs ];
    }

    getAllObjectsWithoutShelfWithExclude(uuids: Array<string>) {
        return this.getAllObjectsWithoutShelf().filter((item) => !uuids.includes(item.uuid));
    }

    getAllObjectsWithExclude(uuids: Array<string>) {
        return this.getAllObjects().filter((item) => !uuids.includes(item.uuid));
    }

    moveCamera(wall: sides | 'standard') {
        return new Promise((resolve) => {
            this.overlayGroup.clear();
            $.selectionBox.unselect();
            $.selectionBoxForBox.unselect();
            switch (wall) {
                case 'front': {
                    this.app.scene.background = new v3d.Color('#ffffff');
                    this.camera.wallFront(true);
                    this.room.oneWallMode(wall);
                    break;
                }
                case 'left': {
                    this.app.scene.background = new v3d.Color('#ffffff');
                    this.camera.wallLeft(true);
                    this.room.oneWallMode(wall);
                    break;
                }
                case 'right': {
                    this.app.scene.background = new v3d.Color('#ffffff');
                    this.camera.wallRight(true);
                    this.room.oneWallMode(wall);
                    break;
                }
                case 'back': {
                    this.app.scene.background = new v3d.Color('#ffffff');
                    this.camera.wallBack(true);
                    this.room.oneWallMode(wall);
                    break;
                }
                case 'standard': {
                    this.app.scene.background = this.sceneBackGround;
                    this.camera.standardCamMode(true);
                    this.room.oneWallMode(wall);
                    break;
                }
            }
            wall != 'standard' ? this.createSizeCaption(wall) : false;
            setTimeout(() => {
                this.render(() => {
                    resolve(null);
                });
            }, 100);
        });
    }


    createSizeCaption(wall: sides) {
        const halfRackWidth = 0.025/2;

        const createLine = (pos1: Array<number>, pos2: Array<number>,
                            withText = true, isDashed = true,textOtherSide=false) => {
            const start = new Vector3(pos1[0], pos1[1], 0.05);
            const end = new Vector3(pos2[0], pos2[1], 0.05);
            const spaceSize = (start.distanceTo(end) * 1000).toFixed(0);
            if (+spaceSize < 5) withText = false;
            const line = getLineMeshWithDashes(start, end, withText ? spaceSize : null, isDashed,textOtherSide);
            this.overlayGroup.add(line);
        };

        const wallHeight = this.room.getHeight();
        const wallWidth = this.room.getWidth(wall);
        const frameMargin = 0.07;
        let lowestRailPoint = 100000;
        if (!wallWidth) return;
        //Линии по периметру стены
        createLine([ 0, wallHeight ], [ wallWidth, wallHeight ], false, false); //Верх
        createLine([ 0, 0 ], [ 0, wallHeight ], false, false); //Лево
        createLine([ wallWidth, 0 ], [ wallWidth, wallHeight ], false, false); //Право
        createLine([ 0, 0 ], [ wallWidth, 0 ], false, false); //Низ
        //Пройтись по всем группам по рейкам
        const racks = this.wardrobe.rackModules.filter((rack) => rack.side === wall)
            .sort((rack1, rack2) => rack1.position.x - rack2.position.x);
        racks.forEach((rackModule, rackIndex) => {
            const railHeight = 0.05;
            // console.log('current rackModule', rackModule);
            let y0 = rackModule.position.y + railHeight / 2;
            const rackCenterX = rackModule.position.x;
            //Построить линию до потолка
            createLine([ rackCenterX, y0 ], [ rackCenterX, wallHeight ]);
            //Показать ширину рейки
            console.log(rackModule.width);
            createLine([ rackCenterX - rackModule.width / 2, y0 ], [ rackCenterX + rackModule.width / 2, y0 ]);
            y0 -= railHeight;
            [ ...rackModule.shelves ].sort((shelf1, shelf2) => shelf2.modelPosition.y - shelf1.modelPosition.y)
                .forEach((shelf, index) => {
                    const shelfY = shelf.modelPosition.y + 0.005;
                    createLine([ rackCenterX, shelfY ], [ rackCenterX, y0 ]);
                    let shelfHeight = shelf.height;
                    if (shelf.items?.shelf) shelfHeight = shelf.items.shelf.height;
                    if (shelf.items?.rod) shelfHeight = shelf.items.rod.height;
                    if (shelf.items?.basket) shelfHeight = shelf.items.basket.height;
                    if (shelf.items?.trouserRack) shelfHeight = shelf.items.trouserRack.height;
                    y0 = shelfY - shelfHeight;
                    if (index == rackModule.shelves.length - 1) {
                        //Построить линию от пола
                        createLine([ rackCenterX, 0 ], [ rackCenterX, y0 ]);
                    }
                });
            //TODO От пола до рельсы
            if (rackModule.position.y - rackModule.height < lowestRailPoint) lowestRailPoint = rackModule.position.y - rackModule.height;

            //Расстояния от стен до краевых модулей
            if (rackIndex == 0) createLine(
                [ 0, wallHeight + frameMargin ], [ -halfRackWidth + rackCenterX - rackModule.width / 2, wallHeight + frameMargin ]); //Самый левый модуль
            if (rackIndex == racks.length - 1) createLine(
                [ halfRackWidth + rackCenterX + rackModule.width / 2, wallHeight + frameMargin ], [ wallWidth, wallHeight + frameMargin ]); //Самый правый модуль
        });
        // console.log('builded racks',wall,racks);
        if (racks.length > 0) {
            //Ширина модулей
            createLine([ - halfRackWidth + racks[0].position.x - racks[0].width / 2, wallHeight + frameMargin ],
                [ halfRackWidth + racks[racks.length - 1].position.x + racks[racks.length - 1].width / 2, wallHeight + frameMargin ]);
            //Высота модулей
            createLine(
                [ wallWidth + frameMargin, lowestRailPoint ],
                [ wallWidth + frameMargin, racks[0].position.y ],
                true,true,true);
            //От потолка и пола до краёв модулей
            createLine(
                [ wallWidth + frameMargin, wallHeight ],
                [ wallWidth + frameMargin, racks[0].position.y ],
                true,true,true); //Сверху
            createLine(
                [ wallWidth + frameMargin, lowestRailPoint ],
                [ wallWidth + frameMargin, 0 ],
                true,true,true); //Снизу
        }

        this.room.addToWall(this.overlayGroup, wall);
    }

    createSizeCaptionOLD(wall: sides) {
        const marginLeft = 0;
        const marginBottom = 0; //-0.18;
        const tectLeftShift = 0;
        const shelves = this.wardrobe.shelves.filter((shelf) => shelf.side === wall);
        shelves.forEach((shelf) => {
            const shelfY = shelf.modelPosition.y;
            const textMesh = new TextMesh(String((shelfY * 1000).toFixed(0)));
            textMesh.model.position.y = shelfY;
            textMesh.model.position.z = 0.05;
            textMesh.model.position.x = marginLeft;
            textMesh.model.scale.set(2, 2, 1);
            this.overlayGroup.add(textMesh.model);
            const line = new LineDotted(new Vector3(0, shelfY, 0.05), new Vector3(this.room.getWidth(wall), shelfY, 0.05), 'dotted', true);
            this.overlayGroup.add(line.model);
            this.room.addToWall(this.overlayGroup, wall);
        });
        const racks = this.wardrobe.rackModules.filter((rack) => rack.side === wall);
        racks.forEach((rack) => {
            const wallHeight = this.room.getHeight();
            //Надпись для левой рейки
            if (rack.rackLeft) {
                const rackLeftX = rack.upLeftPoint.x;
                const textMeshLeft = new TextMesh(String((rackLeftX * 1000).toFixed(0)));
                textMeshLeft.model.position.x = rackLeftX + tectLeftShift;
                textMeshLeft.model.position.z = 0.05;
                textMeshLeft.model.position.y = marginBottom;
                textMeshLeft.model.scale.set(2, 2, 1);
                // textMeshLeft.model.rotation.set(0,0,Math.PI/2);
                this.overlayGroup.add(textMeshLeft.model);
                const lineLeft = new LineDotted(new Vector3(rackLeftX, 0, 0.05), new Vector3(rackLeftX, wallHeight, 0.05), 'dotted', true);
                this.overlayGroup.add(lineLeft.model);
                this.room.addToWall(this.overlayGroup, wall);
            }
            //Надпись для второй рейки
            if (rack.rackRight) {
                const rackRightX = rack.upRightPoint.x;
                const textMeshRight = new TextMesh(String((rackRightX * 1000).toFixed(0)));
                textMeshRight.model.position.x = rackRightX + tectLeftShift;
                textMeshRight.model.position.z = 0.05;
                textMeshRight.model.position.y = marginBottom;
                textMeshRight.model.scale.set(2, 2, 1);
                // textMeshRight.model.rotation.set(0,0,Math.PI/2);
                this.overlayGroup.add(textMeshRight.model);
                const lineRight = new LineDotted(new Vector3(rackRightX, 0, 0.05), new Vector3(rackRightX, wallHeight, 0.05), 'dotted', true);
                this.overlayGroup.add(lineRight.model);
                this.room.addToWall(this.overlayGroup, wall);
            }
        });
        //Показ размеров стены
        const wallHeight = this.room.getHeight();
        const wallWidth = this.room.getWidth(wall);
        const textMeshHeight = new TextMesh(String((wallHeight * 1000).toFixed(0)));
        const textMeshWidth = new TextMesh(String((wallWidth * 1000).toFixed(0)));
        textMeshHeight.model.position.y = wallHeight;
        textMeshHeight.model.position.z = 0.05;
        textMeshHeight.model.position.x = marginLeft;
        textMeshHeight.model.scale.set(2, 2, 1);
        this.overlayGroup.add(textMeshHeight.model);
        textMeshWidth.model.position.x = wallWidth + tectLeftShift;
        textMeshWidth.model.position.z = 0.05;
        textMeshWidth.model.position.y = marginBottom - 0.1;
        textMeshWidth.model.scale.set(2, 2, 1);
        // textMeshWidth.model.rotation.set(0,0,Math.PI/2);
        this.overlayGroup.add(textMeshWidth.model);
        this.room.addToWall(this.overlayGroup, wall);
    }
}

export const $ = new GlobalState();

window.wardrobe = $;
